import useBoardStore from '../store/boardStore';
import useAuthStore from '../store/authStore';
import { isOrgAdmin } from '../utils/permissions';

// Deriva os controles de permissao do quadro atual (currentBoard).
//
// Caminho novo: quando GET /boards/:id/data manda my_access.can (backend
// pos-M1a), usa direto — o servidor ja calculou read/edit_content/
// edit_structure/board_settings/manage_access/archive_delete.
//
// Fallback OBRIGATORIO: se my_access nao vier (backend M1a hoje em producao),
// reproduz EXATAMENTE a regra antiga espalhada em GroupSection/BoardTable/
// BoardToolbar (isOrgAdmin ou boardMembers[].role admin/editor) e em BoardView
// (renomear sempre liberado, convidar/lixeira/registros so isOrgAdmin). Nada
// muda pra quem ainda esta no sistema antigo.
export default function useBoardCan() {
  const myAccess = useBoardStore((s) => s.myAccess);
  const boardMembers = useBoardStore((s) => s.boardMembers);
  const user = useAuthStore((s) => s.user);

  if (myAccess?.can) {
    return myAccess.can;
  }

  const admin = isOrgAdmin(user);
  const boardRole = boardMembers.find((m) => m.user_id === user?.id)?.role;
  const legacyEdit = admin || boardRole === 'admin' || boardRole === 'editor';

  return {
    read: true,
    edit_content: legacyEdit,
    edit_structure: legacyEdit,
    board_settings: true, // hoje sem gate — renomear o quadro sempre foi liberado
    manage_access: admin,
    archive_delete: admin,
  };
}

// true quando o backend ja manda my_access.can nesse board (contrato pos-M1a).
// Uso: alguns controles (Criar tarefa no toolbar; comentar/responder/anexar
// no painel do card) nunca tiveram gate no comportamento atual — diferente
// do restante, onde o fallback e a formula antiga (isOrgAdmin/boardRole), o
// fallback desses e "sempre liberado". Esses componentes fazem:
//   const canEditContent = useHasServerAccess() ? useBoardCan().edit_content : true;
// pra so passar a exigir edit_content quando o backend novo manda my_access
// de fato, sem regredir quem ainda esta no backend M1a.
export function useHasServerAccess() {
  return !!useBoardStore((s) => s.myAccess?.can);
}
